export default __webpack_public_path__ + "static/media/polideportivo.33117c85.jpg";